import { ExerciseConcentricCards, MetricsOptions } from '../types';
import concentricVelocityCards from './concentricVelocityCards.json';

export enum AutomaticMetricsType {
  Tempo = 'Tempo',
  Velocity = 'Velocity',
}

export const DEFAULT_METRICS = {
  concentric: {
    type: AutomaticMetricsType.Tempo,
    min: 0.5,
    max: 1,
  },
  eccentric: {
    type: AutomaticMetricsType.Tempo,
    min: 1,
    max: 2,
  },
};

export const AUTOMATIC_METRICS_OPTIONS: MetricsOptions = {
  [AutomaticMetricsType.Tempo]: [
    {
      texts: {
        school: {
          title: 'Maximal Force',
          concentricRange: '1 - 2 sec',
          eccentricRange: '2 - 4 sec',
          subtitle: 'Maximum force, heavy loads',
        },
        gym: {
          title: 'Hypertrophy Training',
          concentricRange: '1 - 2 sec',
          eccentricRange: '2 - 4 sec',
          subtitle: 'Focusing on muscle growth',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 1,
          max: 2,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 2,
          max: 4,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Explosive Strength',
          concentricRange: '0.75 - 1.25 sec',
          eccentricRange: '1.75 - 2.25 sec',
          subtitle: 'Fast movement, rapid force',
        },
        gym: {
          title: 'Muscle Sculpting',
          concentricRange: '0.75 - 1.25 sec',
          eccentricRange: '1.75 - 2.25 sec',
          subtitle: 'Build muscle, burn fat',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.75,
          max: 1.25,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 1.75,
          max: 2.25,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Max Power Output',
          concentricRange: '0.5 - 1 sec',
          eccentricRange: '1 - 2 sec',
          subtitle: 'Peak power, velocity focus',
        },
        gym: {
          title: 'Athletic Power',
          concentricRange: '0.5 - 1 sec',
          eccentricRange: '1 - 2 sec',
          subtitle: 'Strength and power',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.5,
          max: 1,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 1,
          max: 2,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Force Initiation',
          concentricRange: '0.5 - 1 sec',
          eccentricRange: '1.75 - 2.25 sec',
          subtitle: 'Quick start, acceleration',
        },
        gym: {
          title: 'Building Explosiveness',
          concentricRange: '0.5 - 1 sec',
          eccentricRange: '1.75 - 2.25 sec',
          subtitle: 'Fast twitch power',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.5,
          max: 1,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 1.75,
          max: 2.25,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Sustained Load',
          concentricRange: '0.75 - 1.25 sec',
          eccentricRange: '0.75 - 1.25 sec',
          subtitle: 'Strength, endurance',
        },
        gym: {
          title: 'Sustained Load',
          concentricRange: '0.75 - 1.25 sec',
          eccentricRange: '0.75 - 1.25 sec',
          subtitle: 'Strength, endurance',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.75,
          max: 1.25,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.75,
          max: 1.25,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Elastic Force',
          concentricRange: '0.4 - 0.6 sec',
          eccentricRange: '0.5 - 1 sec',
          subtitle: 'Rebound, reactive strength',
        },
        gym: {
          title: 'Elastic Force',
          concentricRange: '0.4 - 0.6 sec',
          eccentricRange: '0.5 - 1 sec',
          subtitle: 'Rebound, reactive strength',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.4,
          max: 0.6,
        },
        eccentric: {
          type: AutomaticMetricsType.Tempo,
          min: 0.5,
          max: 1,
        },
      },
    },
  ],
  [AutomaticMetricsType.Velocity]: [
    {
      texts: {
        school: {
          title: 'Maximal Force',
          concentricRange: '<0.5 m/s',
          eccentricRange: '<0.3 m/s',
          subtitle: 'Maximum force, heavy loads',
        },
        gym: {
          title: 'Hypertrophy Training',
          concentricRange: '<0.5 m/s',
          eccentricRange: '<0.3 m/s',
          subtitle: 'Focusing on muscle growth',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0,
          max: 0.5,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0,
          max: 0.3,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Explosive Strength',
          concentricRange: '0.5 - 0.75 m/s',
          eccentricRange: '0.3 - 0.5 m/s',
          subtitle: 'Fast movement, rapid force',
        },
        gym: {
          title: 'Muscle Sculpting',
          concentricRange: '0.5 - 0.75 m/s',
          eccentricRange: '0.3 - 0.5 m/s',
          subtitle: 'Build muscle, burn fat',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.5,
          max: 0.75,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.3,
          max: 0.5,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Max Power Output',
          concentricRange: '>1.0 m/s',
          eccentricRange: '0.5 - 0.75 m/s',
          subtitle: 'Peak power, velocity focus',
        },
        gym: {
          title: 'Athletic Power',
          concentricRange: '>1.0 m/s',
          eccentricRange: '0.5 - 0.75 m/s',
          subtitle: 'Strength and power',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 1,
          max: 10,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.5,
          max: 0.75,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Force Initiation',
          concentricRange: '0.75 - 1.0 m/s',
          eccentricRange: '0.3 - 0.5 m/s',
          subtitle: 'Quick start, acceleration',
        },
        gym: {
          title: 'Building Explosiveness',
          concentricRange: '0.75 - 1.0 m/s',
          eccentricRange: '0.3 - 0.5 m/s',
          subtitle: 'Fast twitch power',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.75,
          max: 1,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.3,
          max: 0.5,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Sustained Load',
          concentricRange: '0.75 - 1.25 m/s',
          eccentricRange: '0.5 - 0.75 m/s',
          subtitle: 'Strength, endurance',
        },
        gym: {
          title: 'Sustained Load',
          concentricRange: '0.75 - 1.25 m/s',
          eccentricRange: '0.5 - 0.75 m/s',
          subtitle: 'Strength, endurance',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.75,
          max: 1.25,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 0.5,
          max: 0.75,
        },
      },
    },
    {
      texts: {
        school: {
          title: 'Elastic Force',
          concentricRange: '>1.3 m/s',
          eccentricRange: '>1.0 m/s',
          subtitle: 'Rebound, reactive strength',
        },
        gym: {
          title: 'Elastic Force',
          concentricRange: '>1.3 m/s',
          eccentricRange: '>1.0 m/s',
          subtitle: 'Rebound, reactive strength',
        },
      },
      metrics: {
        concentric: {
          type: AutomaticMetricsType.Velocity,
          min: 1.3,
          max: 10,
        },
        eccentric: {
          type: AutomaticMetricsType.Velocity,
          min: 1,
          max: 10,
        },
      },
    },
  ],
};

export const CONCENTRIC_VELOCITY_CARDS: ExerciseConcentricCards[] =
  concentricVelocityCards;
